import { render, staticRenderFns } from "./SeverityHemophiliaByGenderAndGNI.vue?vue&type=template&id=8b89ca98"
import script from "./SeverityHemophiliaByGenderAndGNI.vue?vue&type=script&lang=ts"
export * from "./SeverityHemophiliaByGenderAndGNI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports